var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('Header'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('go-top',{attrs:{"bg-color":"#ff5500"}}),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }